import { BilbyHeader } from '@/components/bilby-header';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CustomContentSection } from '@/components/custom-content-section';
import { ScrollTop } from '@/components/scroll-top';
import { useLayoutContext } from '@/contexts';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex } from '@mantine/core';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { useMemo } from 'react';
import {
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const TermsPage = () => {
	const navigate = useNavigate();
	const router = useRouter();
	const { isDesktop } = useLayoutContext();

	const goToSignUpButton = useMemo(
		() => (
			<StandardButton key={1} variant="filled" onClick={() => navigate({ to: '/signup' })}>
				Sign Up
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout footer={{ children: [goToSignUpButton] }}>
			<ContentPanel noPad gap="xl" pt="xl">
				<BilbyHeader title="Terms & Conditions" subtitle="Curby 2025 Promotion" bilby="lawyer">
					<Flex align="center" gap="lg">
						<a onClick={() => router.history.back()} className={styles.downloadLink}>
							Go Back
						</a>
					</Flex>
				</BilbyHeader>
				<CustomContentSection
					location={ContentSectionLocation.Terms}
					placement={ContentSectionPlacement.Middle}
				/>
				{isDesktop && <ScrollTop />}
			</ContentPanel>
		</PrimaryLayout>
	);
};
